import { client } from "@/utils/client";

export function addLanguage(language, description, token) {
    const data = {
        language,
        description,
        token
    }
    return client({
        url: "/console/language",
        method: "post",
        data
    })
}

export function deleteLanguage(language, token) {
    return client({
        url: "/console/language?language=" + language + "&token=" + token,
        method: "delete"
    })
}


//////////////////
// WEBPACK FOOTER
// ./src/api/language.js
// module id = null
// module chunks = 